<!-- Main Container -->
<main class="site-content fix-height">
  <div class="container mfa-challenge">
    <!-- Logo -->
    <div class="logo">
      <img src="/assets/images/qunote-logo-g.svg" alt="qunote">
    </div>
    <!-- Error Message Display Div -->
    <p-message *ngFor="let msg of msgs" closable [severity]="msg.severity" [text]="msg.summary"></p-message>
    <div class="form-heading mfa-title">
      <h1>{{'login.mfa.title' | translate}}</h1>
    </div>
    <div class="mfa-message">
      {{'login.mfa.text' | translate}}
    </div>
    <form [formGroup]="mfaForm" (ngSubmit)="onSubmit()" id="mfa-challenge" class="front">
      <div class="input-row">
        <div class="input-field">
          <input type="text" class="input" id="inputMfaCode"
            placeholder="{{'login.mfa.placeholder' | translate}}" formControlName="challengeCode" (keypress)="codeLength($event)" 
            [ngClass]="{'is-invalid': f.challengeCode.errors && f.challengeCode.dirty }">
          <!-- Email Validations and Error Message -->
          <div *ngIf="f.challengeCode.errors && f.challengeCode.dirty" class="invalid-feedback">
            <div *ngIf="f.challengeCode.errors.required" class="error-message-form">{{'login.mfa.required' | translate}}</div>
            <div *ngIf="(f.challengeCode.errors.email || f.challengeCode.invalid) && f.challengeCode.value" class="error-message-form">
              {{ 'login.mfa.valid' | translate}}</div>
            <!-- <div *ngIf="(f.email.errors.maxlength)" class="error-message-form">
            Email must not exceed 100 characters</div> -->
          </div>
        </div>
      </div>
      <div class="btns">
        <button class="btn btn-secondary btn-block submit" type="submit" [disabled]="!mfaForm.valid"
          [style.display]="submitted?'none':''">
          {{'login.mfa.continue' | translate}}
        </button>
        <div class="mfa-options">
          <input type="button" name="" class="btn btn-link mfa-btn-left"
            value="{{'login.mfa.back' | translate}}" (click)="backToLogin()"> | 
          <input type="button" name="" class="btn" id="resend-code-login"
            value="{{'login.mfa.resend' | translate}}" [disabled]="limitResend" (click)="resendCode()">
        </div>
      </div>
    </form>
  </div>
</main>